/* eslint-disable indent */
import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import BlogCard from '../blog-card'
import LeftArrow from '../svgs/LeftCircleArrow'
import RightArrow from '../svgs/RightCircleArrow'
import Button from '../button'
import * as styles from './relatedPost.module.scss'

function formatDate(isoDateString) {
  const date = new Date(isoDateString);
  const now = new Date();

  const diffMilliseconds = now - date;
  const diffSeconds = Math.floor(diffMilliseconds / 1000);
  const diffMinutes = Math.floor(diffSeconds / 60);
  const diffHours = Math.floor(diffMinutes / 60);
  const diffDays = Math.floor(diffHours / 24);
  const diffMonths = Math.floor(diffDays / 30);
  const diffYears = Math.floor(diffDays / 365);

  if (diffSeconds < 60) {
    return `${diffSeconds} seconds ago`;
  } else if (diffMinutes < 60) {
    return `${diffMinutes} minutes ago`;
  } else if (diffHours < 24) {
    return `${diffHours} hours ago`;
  } else if (diffDays < 30) {
    return `${diffDays} days ago`;
  } else if (diffMonths < 12) {
    return `${diffMonths} months ago`;
  } else {
    return `${diffYears} years ago`;
  }
}

function RelatedPosts({ data }) {
  const [posts, setPosts] = useState(null)
  const limit = 3
  const [indexes, setIndexes] = useState({ start: 0, end: 3 })

  const onPostNavigate = (action) => {
    if (action === 'prev') {
      setIndexes((prev) => ({ start: prev.start - 1, end: prev.end - 1 }))
    } else if (action === 'next') {
      setIndexes((prev) => ({ start: prev.start + 1, end: prev.end + 1 }))
    }
  }

  useEffect(() => {
    if (data) {
      setPosts([...data].slice(indexes.start, indexes.end))
    }
  }, [data, indexes])
  const newdata = data
  newdata.flag=true
  return data && newdata && newdata.length > 0 ? (
    <div className={`${styles.relatedPostsContainer}`}>
      <div
        className={`d-flex align-items-center justify-content-between ${styles.headerContainer}`}
      >
        <div className={`${styles.titleContainer}`}>
          <p> Related Posts</p>
        </div>
        {data.length > limit ? (
          <div className={`${styles.arrowContainer}`}>
            {indexes.start !== 0 ? (
              <Button
                className={`projectBtn ${styles.arrowBtn}`}
                onClick={() => onPostNavigate('prev')}
              >
                <LeftArrow className={`${styles.arrowIcon}`} />
              </Button>
            ) : null}
            {indexes.end < data.length ? (
              <Button
                className={`projectBtn ${styles.arrowBtn}`}
                onClick={() => onPostNavigate('next')}
              >
                <RightArrow className={`${styles.arrowIcon}`} />
              </Button>
            ) : null}
          </div>
        ) : null}
      </div>
      <div className={`d-sm-flex ${styles.flexContainer}`}>
        {posts && posts.length > 0
          ? posts.map(
              ({
                id,
                slug,
                blogCategories,
                blogTitle,
                blogTags,  // Add this line to check if blogTags is defined
                blogPublishDate,
                readingTime,
                blogCoverImage,
                blogAuthor,
                flag
              }) => (
                <BlogCard
                  key={id}
                  categories={blogCategories.nodes}
                  tags={blogTags ? blogTags.nodes : []}  // Check if blogTags is defined
                  title={blogTitle}
                  published_date={formatDate(blogPublishDate)}
                  slug={slug}
                  featuredImage={blogCoverImage.node.sourceUrl}
                  reading_time={readingTime}
                  blogAuthor={blogAuthor ? blogAuthor.node.name : ''}
                  flag={flag}
                />
              ),
            )
          : null}
      </div>
    </div>
  ) : null
}

RelatedPosts.propTypes = {
  data: PropTypes.instanceOf(Array).isRequired,
}

export default RelatedPosts
